import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import MineArticles from "../MineArticles";
import Footer from "../Footer";

import Tooltip from "@mui/material/Tooltip";
import VerifiedIcon from "@mui/icons-material/Verified";
import "./../../App.css";
import Spinner from "../Spinner";


const OthersProfile = () => {
  const iniialValue = {
    user: "",
    updateBlogAt: "",
    facebook: "",
    instagram: "",
    twitter: "",
    linkedln: "",
  };

  const navigate = useNavigate();
  const [otherProfile, setOtherProfile] = useState(iniialValue);
  const userId = useParams();
  const [isLoading, setLoading] = useState(true);

  const othersProfilePageFn = async () => {
    try {
      const res = await Axios.get(
        `https://blogappserver-8sw1.onrender.com/profile/${userId.id}`
      );
      const data = res.data;
      setOtherProfile(data);

      if (!(res.status === 200)) {
        const error = new Error(res.error);
        throw error;
      }
    } catch (error) {
      navigate("/login", { replace: true });
    }
  };

  useEffect(() => {
    othersProfilePageFn();

    // Simulating data loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //contact to blogger
  const writeEmailToFn = ({ email }) => {
    const encodedEmail = encodeURIComponent(email);
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodedEmail}`;
    window.open(url, "_blank");
  };
  const { user, about, facebook, instagram, twitter, linkedln } = otherProfile;

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card">
                <div className="text-center mt-3">
                <Tooltip title="Update ProfilePic">
                  <img
                    src={user ? user.profilepic : ""}
                    width="120"
                    height="120"
                    alt=""
                    className="rounded-circle border border-dark"
                  />
                  </Tooltip>
                </div>

                <div className="card-body text-center mt-3">
                  <h3 className="card-title">
                    <VerifiedIcon className="fs-3" style={{ color: "blue" }} />
                    {user?.name}
                  </h3>
                  <p className="card-text">{user?.email}</p>
                  <div className="mt-3">
                    <h5 className="fw-medium">About Me</h5>
                    <p className="text-muted">{about}</p>
                  </div>

                  <div className="mt-3">
                    <h5 className="fw-medium">Blogs Written By Me..!!</h5>
                    <MineArticles userID={user?._id} />
                  </div>
                </div>

                <div className="card-footer text-center">
                  <ul className="list-inline social-list">
                    <li className="list-inline-item">
                      <a
                        href={`https://facebook.com/${facebook}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        <i className="fa fa-facebook fs-2" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href={`https://instagram.com/${instagram}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        <i className="fa fa-instagram fs-2" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href={`https://linkedin.com/${linkedln}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        <i className="fa fa-linkedin fs-2" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href={`https://twitter.com/${twitter}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        <i className="fa fa-twitter fs-2" />
                      </a>
                    </li>
                  </ul>
                  <div>
                    <Tooltip title="write a mail to contact">
                      <button
                        type="button"
                        onClick={() => writeEmailToFn(user)}
                        className="btn btn-primary btn-sm"
                      >
                        Contact Me
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default OthersProfile;
